/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Discord_None_TInputs */



/**
* | output |
* | --- |
* | "No Discord, no bot" |
*
* @param {Tournament_Wiz_Tip_Discord_None_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_discord_none_t = /** @type {((inputs?: Tournament_Wiz_Tip_Discord_None_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Discord_None_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas de Discord, pas de bot")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin Discord, sin bot")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem Discord, sem bot")
	if (locale === "it") return /** @type {LocalizedString} */ ("Niente Discord, niente bot")
	return /** @type {LocalizedString} */ ("No Discord, no bot")
});